var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',[_c('el-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',[_c('AuthStatusCpt',{staticClass:"auth-status"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }